import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CardLayout from '../../components/utils/CardLayout'
import SideButtons from '../../components/utils/SideButtons';
import Table from '../../components/utils/Table';
import Modal from '../../components/utils/Model';
import Button from '../../components/utils/Button';
import { useForm, Controller } from "react-hook-form";
import DeleteBin5Fill from 'remixicon-react/DeleteBin5FillIcon';
import Popconfirm from '../../components/utils/Popover';
import { Link } from 'react-router-dom';
import Tag from '../../components/utils/Tag';
import moment from 'moment';
import Alert from '../../components/utils/Alert';
import Select from 'react-select';
import dealerAction from '../../redux/dealer/actions'
import apiKeyAction from '../../redux/apiKey/actions'

const { getDealer } = dealerAction;
const { getApiKey, openApiKeyModal, closeApiKeyModal, addUpdateApiKey, resetMessage, resetSearchData } = apiKeyAction;

function ApiKey() {
    const dispatch = useDispatch();
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const [apiKeyItemId, setApiKeyItemId] = useState()
    const [searched, setSearched] = useState(false);
    const [selectedDealer, setSelectedDealer] = useState({});
    const { dealerResult } = useSelector((state) => state.dealer);
    const { loading, getApiKeyError, apiKeyError, apiKeyMessage, buttonLoading, apiKeyResult, apiKeyFormModal } = useSelector((state) => state.apiKey);

    const [fromData, setFromData] = useState({ apiKey: "", })
    const [searchData, setSearchData] = useState({ dealer: "", })

    const { register: registerregister, handleSubmit: handleDealerSubmit, formState: { errors: errorerror }, control: searchControl } = useForm({
        defaultValues: searchData,
    });

    const { register, handleSubmit, formState: { errors }, watch, reset: resetForm, control, setValue, setError } = useForm({
        defaultValues: fromData,
    });

    useEffect(() => {
        dispatch(getDealer());
        return () => {
            dispatch(resetMessage());
        };
    }, [])

    let columns = [
        { displayName: '#', key: 'key' },
        { displayName: 'API KEY', key: 'apiKey' },
        { displayName: 'CREATED DATE', key: 'createdDate' },
        { displayName: 'CREATED BY', key: 'createdBy' },
        { displayName: 'MODIFIED DATE', key: 'modifiedDate' },
        { displayName: 'MODIFIED BY', key: 'modifiedBy' },
        { displayName: 'STATUS', key: 'status' },
        { displayName: 'ACTION', key: 'action' }
    ];


    useEffect(() => {
        if (getApiKeyError !== null && getApiKeyError !== undefined) {
            displayAlert(getApiKeyError, 'alert-danger');
        }
        if (apiKeyError !== null && apiKeyError !== undefined) {
            displayAlert(apiKeyError, 'alert-danger');
        }
        if (apiKeyMessage !== null && apiKeyMessage !== undefined) {
            displayAlert(apiKeyMessage, 'alert-success');
            resetForm()
        }

    }, [getApiKeyError, apiKeyError, apiKeyMessage]);

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetMessage());
    }
    const options = dealerResult && dealerResult.length > 0 && dealerResult.filter(dealer => dealer.ParentID != 0 && dealer.IsActive == 1).map(dealer => ({
        label: dealer.DealerName,
        value: dealer.ID,
    }));

    const dataSource = apiKeyResult && apiKeyResult.length > 0 && apiKeyResult.map((data, key) => {
        var actionContent = (
            <>
                {buttonLoading && apiKeyItemId === data.ID ? <span className="spinner-border spinner-border-sm" role="status"></span> : data.IsActive === 1 ? (
                    <Popconfirm
                        title="Are you sure to inactive this API key?"
                        okText="Yes"
                        cancelText="No"
                        placement="topRight"
                        onConfirm={() => handleDelete(data.ID, 0)}
                    >
                        <Link className="deleteBtn" to="# ">
                            <span data-toggle="tooltip" data-placement="top" title="Inactive">
                                <DeleteBin5Fill size="1.2em" style={{ color: "#f14336", marginRight: "3px" }} />
                            </span>
                        </Link>
                    </Popconfirm>

                ) : (
                    ''
                )}
            </>
        );
        return {
            key: key + 1,
            apiKey: data.ApiKey,
            createdBy: data.CreatedBy,
            createdDate: data.CreatedDtTm !== null ? moment(new Date(data.CreatedDtTm)).format(`${process.env.REACT_APP_DATE_FORMAT}`) : 'N/A',
            modifiedBy: data.ModifiedBy,
            modifiedDate: data.ModifiedDtTm !== null ? moment(new Date(data.ModifiedDtTm)).format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
            status: <Tag color={`${data.IsActive === 1 ? "badge-success" : "badge-danger"}`} title={data.IsActive === 1 ? 'Active' : 'Inactive'} />,
            action: actionContent,
        }
    });

    const renderApiKeyTable = () => {
        if (searched) {
            return (
                <Table columns={columns} data={dataSource} loading={loading} pagination={true} />
            );
        } else {
            return null;
        };
    }

    const handleCancel = () => {
        dispatch(closeApiKeyModal());
        resetForm()
    };

    const handleOpenAddFormModal = () => {
        dispatch(openApiKeyModal());
    }

    const onSubmit = (data) => {
        const newData = {
            apiKey: data?.apiKey,
            dealerId: selectedDealer?.value,
        }
        dispatch(addUpdateApiKey(newData));
    }

    const handleDelete = (ID, flag) => {
        setApiKeyItemId(ID)
        const newData = {
            apiKeyId: ID,
            status: flag,
            dealerId: selectedDealer?.value,
        }
        dispatch(addUpdateApiKey(newData));
    }

    const onDealerSubmit = (data) => {
        alertCancel();
        setSearched(true);
        setSelectedDealer(data?.dealer);
        dispatch(getApiKey(data?.dealer?.value))
    }

    const generateApiKey = () => {
        const length = 31;
        const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let newKey = 'mvno_';
        for (let i = 0; i < length; i++) {
            newKey += charset.charAt(Math.floor(Math.random() * charset.length));
        }
        setValue('apiKey', newKey);
        setError('apiKey', '')
    };

    const handleDealerChange = () => {
        dispatch(resetSearchData())
        setSearched(false);
    }

    return (
        <CardLayout title="API Keys">
            {showAlert && !apiKeyError && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}
            <form onSubmit={handleDealerSubmit(onDealerSubmit)} >
                <div className="form-row planNetwork">
                    <div className="col-lg-3 col-md-3">
                        <label>Dealer</label>
                        <Controller
                            control={searchControl}
                            name="dealer" {...registerregister("dealer", {
                                required: true,
                            })}
                            render={({
                                field: { onChange, onBlur, value, name, ref },
                            }) => (
                                <Select
                                    options={options}
                                    onChange={(selected) => {
                                        onChange(selected);
                                        handleDealerChange();
                                    }}
                                    onBlur={onBlur}
                                    value={value}
                                    name={name}
                                    ref={ref}
                                />
                            )}
                        />
                        {errorerror.dealer?.type === "required" && (<div className="invalid-feedback">Dealer required!</div>)}
                    </div>
                    <div className="networkSearchBtn">
                        <Button title="Search" style="minWidth:80px" buttonClass={` btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`} buttonType='submit' />
                    </div>
                </div>
            </form>

            {searched ?
                <div className="row align-items-baseline">
                    <div className='col-lg-12 col-md-12 text-right'>
                        {<SideButtons title="Add API Key" buttonStyle="primary" onClick={handleOpenAddFormModal} />}
                    </div>
                </div>
                : ""}

            {renderApiKeyTable()}

            <Modal
                showModal={apiKeyFormModal}
                title={'Add API Key'}
                onHide={handleCancel}
                width={700}
                showFooter={false}
            >
                {showAlert && apiKeyError && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-row">
                        <div className="col-md-10 mb-1" style={{ height: '91px' }}>
                            <label>API Key</label>
                            <input type="text" placeholder="Generate API Key..." className="form-control" disabled={true}
                                name="apiKey" {...register("apiKey", {
                                    required: true,
                                })} />
                            {errors.apiKey?.type === "required" && (<div className="invalid-feedback">API key is required !</div>)}
                        </div>
                        <div className="col-md-2 mb-1 d-flex flex-column justify-content-center">
                            <div style={{ marginTop: '6px' }}>
                                <Button title={'Generate'} onClick={() => generateApiKey()} style="minWidth:80px" buttonClass="btn btn-primary" loading={false} buttonType='button' />
                            </div>
                        </div>
                        <div className="col-md-12 mb-2">
                            {<i style={{ opacity: '0.7', color: "red", fontSize: '12px' }}>Note - Once your new API key is added, the previous API key is automatically deactivated.</i>}
                        </div>
                    </div>
                    <hr />
                    <div className='text-right row'>
                        <div className="col-md-12">
                            <button type="button" className="btn btn-secondary mr-2" onClick={handleCancel}>Close</button>
                            <Button title={'Submit'} style="minWidth:80px" buttonClass="btn btn-primary" loading={buttonLoading} buttonType='submit' />
                        </div>
                    </div>
                </form>
            </Modal>

        </CardLayout>
    )
}

export default ApiKey